import { BaseResourceModel } from "../../models/base-resource.model";
import { Orgao } from "../comum/orgao.model";

export class AssinaturaEtapa extends BaseResourceModel {
    constructor(
        public id?: number,
        public nome?: 'NOVA_REQUISICAO' | 'NOVA_COMPRA' | 'NOVO_EMPENHO',
        public orgao?: Orgao,
    ) {
        super();
    }

    static converteJson(json: any): AssinaturaEtapa {
        return Object.assign(new AssinaturaEtapa(), json);
    }
}
